import React, { Component } from "react";

import SEO from "../common/SEO";
import { FAQ_ITEMS } from "../../constants";
import Header from "../common/Header";
import Footer from "../common/Footer";

import Myself from "./about/Myself";
import Certificates from "./about/Certificates";
import Tech from "./about/Tech";
import FAQ from "../common/FAQ";

import Preloader from "../../hocs/Preloader";

class About extends Component {
  render() {
    return (
      <div id="page-container" className="full-height">
        <SEO
          title="Fernan de Dios | Technical lead, consultant and SaaS founder"
          description="Fernan de Dios is a technical consultant, AI and LLM practitioner, product builder, and SaaS founder who takes digital products from idea to launch."
          path="/"
        />
        <Header
          id="header-banner"
          title="Technical lead, consultant and SaaS founder"
          sub="Fernan de Dios is a technical developer, AI and LLM practitioner, product builder, and SaaS founder who takes digital products from idea to launch."
        />
        <Myself />
        <Certificates />
        <Tech />
        <FAQ items={FAQ_ITEMS} />
        <Footer />
      </div>
    );
  }
}

export default Preloader(About);
